// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var ticketing = {
  path: '/ticketing',
  component: Layout,
  redirect: '/ticketing/product-list',
  name: 'Ticketing',
  meta: {
    title: '票务',
    icon: 'clipboard'
  },
  children: [{
    path: 'product-list',
    component: function component() {
      return import('@/views/ticketing/productList.vue');
    },
    name: 'TicketingProductList',
    meta: {
      title: '票务',
      icon: ''
    }
  }, {
    path: 'back-list',
    component: function component() {
      return import('@/views/ticketing/back-list.vue');
    },
    name: 'backList',
    meta: {
      title: '退货规则',
      icon: ''
    }
  }, {
    path: 'limit-list',
    component: function component() {
      return import('@/views/ticketing/limit-list.vue');
    },
    name: 'limitList',
    meta: {
      title: '限购规则',
      icon: ''
    }
  },
  // 添加新的门票添加路由
  {
    path: 'list/creatProduct/:id?/:isDisabled?/:isCopy?/:scenicSpotType?',
    component: function component() {
      return import('@/views/ticketing/creatProduct/index');
    },
    name: 'TicketingCreateProduct',
    meta: {
      title: '门票添加',
      noCache: true,
      activeMenu: "/ticketing/product-list"
    },
    hidden: true
  }]
};
export default ticketing;